export const formatWhatsAppMessage = (message, currentUser) => {
  if (!message || !currentUser) {
    return null;
  }

  const msgId = message.id && typeof message.id === 'object' ? message.id.id : message.id;
  const remote = message.id && typeof message.id === 'object' ? message.id.remote : null;

  const formatted = {
    id: msgId ?? message.id,
    message: message.body || message.message || '',
    type: message.fromMe ? 1 : 0,
    read_at: message.read_at ?? (message.ack === 3 ? new Date().toISOString() : null),
    archive: message.hasMedia ? message.mediaData?.data : null,
    room_id: remote || message.room_id,
    user_id: currentUser.id,
    created_at: message.created_at || message.timestamp || message.t,
    updated_at: message.updated_at || message.timestamp || message.t,
    user: currentUser,
    whatsapp: true,
    whatsapp_message_id: msgId,
    meta: message.meta || null,
  };

  if (message.type === 'revoked') {
    formatted.message = 'Mensagem deletada para todos';
    formatted.meta = {
      customType: 'revoked',
    };
  }

  if (message.type === 'vcard' && message.vCards?.length) {
    formatted.message = 'Cartão de Contato';
    const m = message.meta || {};
    const c = m.contactInfo || {};
    formatted.meta = {
      message: m.message || 'Cartão de Contato',
      customType: m.customType || 'contact_card',
      contactInfo: {
        name: c.name ?? 'Contato',
        number: c.number ?? '',
        profilePicUrl: c.profilePicUrl ?? null,
      },
    };
  }

  if (
    message.type === 'notification_template' &&
    message._data?.subtype === 'contact_info_card' &&
    message.contactInfo
  ) {
    formatted.message = 'Cartão de Contato';
    formatted.meta = {
      message: 'Cartão de Contato',
      customType: 'contact_card',
      contactInfo: {
        name: message.contactInfo.name,
        number: message.contactInfo.number,
        profilePicUrl: message.contactInfo.profilePicUrl,
      },
    };
  }

  return formatted;
};
